angular.module('impactx.opengovernmentdata').service('EformsHandoffService', [
    'NewWindowService',
    EformsHandoffService
]);

/**
 * AngularJS counterpart of the Angular EformsHandoffService
 * (upgrade/src/app/modules/shop/eformshandoff/eforms-handoff.service.ts).
 *
 * Both exist on purpose: the order lists and the order detail still run through their AngularJS
 * routes -- checkAngularRoute() in shared/util/impactX.js drops the Angular template for every route
 * that is not listed in activeAngularRoutes, and that list is empty. The Angular components are
 * already in place for the time the routes are switched over. Keep the two in sync until the
 * AngularJS variants are removed.
 */
function EformsHandoffService(NewWindowService) {
    var self = this;

    /**
     * Name of the target window. A fixed name on purpose: a second jump reuses the same window
     * instead of piling up tabs.
     */
    var TARGET_WINDOW = 'eformsHandoff';

    /**
     * Opens the intermediate page for the given order in a separate window.
     *
     * Must run SYNCHRONOUSLY inside the click handler. Fetching anything first would spend the user
     * gesture, and the popup blocker would kill the window -- therefore this method loads nothing.
     * A blocked window is reported by NewWindowService, so the jump never fails silently.
     *
     * @param pohId id of the purchase order to announce.
     */
    self.openHandoff = function (pohId) {
        NewWindowService.openNewWindow(buildHandoffUrl(pohId), TARGET_WINDOW);
    };

    /**
     * The URL has to be absolute, otherwise it would resolve against the target window instead of
     * the running application. It is derived from the current document, which keeps the deployment
     * path and any query string intact. AngularJS routes with hashPrefix('') (base/app.module.js),
     * hence the plain "#/" form.
     */
    function buildHandoffUrl(pohId) {
        var location = window.location;
        return location.origin + location.pathname + location.search + '#/eformshandoff/' + pohId;
    }
}
